/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ muscle: NonNullable<unknown> }} Prescription_Reason_Person_PrefersInputs */

const en_us2_prescription_reason_person_prefers = /** @type {(inputs: Prescription_Reason_Person_PrefersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You said you like this one, for ${i?.muscle}`)
};

const pt_br2_prescription_reason_person_prefers = /** @type {(inputs: Prescription_Reason_Person_PrefersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Você disse que gosta deste, para ${i?.muscle}`)
};

const es_419_prescription_reason_person_prefers = /** @type {(inputs: Prescription_Reason_Person_PrefersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dijiste que te gusta este, para ${i?.muscle}`)
};

const pt_pt2_prescription_reason_person_prefers = /** @type {(inputs: Prescription_Reason_Person_PrefersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Disseste que gostas deste, para ${i?.muscle}`)
};

const fr_fr2_prescription_reason_person_prefers = /** @type {(inputs: Prescription_Reason_Person_PrefersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu as dit que tu aimais celui-ci, pour ${i?.muscle}`)
};

const de_de2_prescription_reason_person_prefers = /** @type {(inputs: Prescription_Reason_Person_PrefersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du hast gesagt, dass du diese magst, für ${i?.muscle}`)
};

const it_it2_prescription_reason_person_prefers = /** @type {(inputs: Prescription_Reason_Person_PrefersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hai detto che ti piace, per ${i?.muscle}`)
};

/**
* | output |
* | --- |
* | "You said you like this one, for {muscle}" |
*
* @param {Prescription_Reason_Person_PrefersInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_reason_person_prefers = /** @type {((inputs: Prescription_Reason_Person_PrefersInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Reason_Person_PrefersInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_reason_person_prefers(inputs)
	if (locale === "es-419") return es_419_prescription_reason_person_prefers(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_reason_person_prefers(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_reason_person_prefers(inputs)
	if (locale === "de-DE") return de_de2_prescription_reason_person_prefers(inputs)
	if (locale === "it-IT") return it_it2_prescription_reason_person_prefers(inputs)
	return en_us2_prescription_reason_person_prefers(inputs)
});
export { prescription_reason_person_prefers as "prescription.reason.person_prefers" }